export const base64ToFile = (base64: string, filename: string): File => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || '';
  const byteString = atob(arr[1]);
  let n = byteString.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = byteString.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
